import { Stack, TextField } from "@mui/material";
import type { PublicCheckoutCustomer } from "../api/types";

interface Props {
  value: PublicCheckoutCustomer;
  errors: Partial<Record<keyof PublicCheckoutCustomer, string>>;
  disabled?: boolean;
  onChange: (v: PublicCheckoutCustomer) => void;
}

export function CustomerForm({ value, errors, disabled, onChange }: Props) {
  const set = <K extends keyof PublicCheckoutCustomer>(k: K, v: string) => {
    onChange({ ...value, [k]: v || undefined });
  };

  return (
    <Stack spacing={2}>
      <TextField
        label="Email"
        type="email"
        autoComplete="email"
        required
        value={value.email ?? ""}
        onChange={(e) => set("email", e.target.value.trim())}
        error={Boolean(errors.email)}
        helperText={errors.email}
        disabled={disabled}
        inputProps={{ maxLength: 254 }}
      />
      <TextField
        label="Nombre completo"
        autoComplete="name"
        value={value.name ?? ""}
        onChange={(e) => set("name", e.target.value)}
        error={Boolean(errors.name)}
        helperText={errors.name}
        disabled={disabled}
        inputProps={{ maxLength: 120 }}
      />
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <TextField
          label="Documento"
          value={value.docNumber ?? ""}
          onChange={(e) => set("docNumber", e.target.value.trim())}
          disabled={disabled}
          inputProps={{ maxLength: 30 }}
        />
        <TextField
          label="Teléfono"
          autoComplete="tel"
          value={value.phone ?? ""}
          onChange={(e) => set("phone", e.target.value.trim())}
          disabled={disabled}
          inputProps={{ maxLength: 30 }}
        />
      </Stack>
    </Stack>
  );
}
